import { getAll } from '../../api';

// state
const state = {
  mapData: null,
  devices: [],
  groupLocations: [],
  devicesReady: false,
  unitInfo: {
    ids: [],
    groupIds: [],
  },
};

// getters
const getters = {
  getDevices(state) {
    const filteredArray = state.devices.filter(
      (device) => device.latitude !== null,
    );
    return filteredArray;
  },
  getUnitInfo(state) {
    return state.unitInfo;
  },
  getDevicesReady(state) {
    return state.devicesReady;
  },
  getGroupLocations(state) {
    return state.groupLocations;
  },
};

// actions
const actions = {
  getDeviceLocations: async ({ commit, rootState, rootGetters }, payload) => new Promise((resolve, reject) => {
    commit('loading/setLoading', true, { root: true });
    let variables = {};
    const filters = rootState.filters.filter;

    const user_groups = rootGetters['account/getCurrentUser'].group_id
        && rootGetters['account/getCurrentUser'].group_id[0];
    if (user_groups && user_groups !== 'all') {
      variables.group_id = user_groups;
    } else {
      if (filters.location !== undefined && filters.location !== '') {
        variables.group_id = filters.location;
      }
      if (filters.group !== undefined && filters.group !== '') {
        variables.group_id = filters.group;
      }
    }

    if (filters.area !== undefined && filters.area !== '') {
      variables.area_id = filters.area;
    }

    variables = JSON.stringify(variables).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/coordinate?query=${
        encodeURIComponent(
          `{getPaginated(type_name: "coordinate", 
            filters: ${variables}
            table_name: "${payload.table_name}", 
            index: "created-index",
            pageSize: "1000",
        ){items{
            area_id, 
            group_id, 
            store_id, 
            screen_id, 
            session_id, 
            latitude, 
            longitude, 
            created_at, 
            timestamp, 
            error, 
            success
          }}}`,
        )}`,
    )
      .then((res) => {
        const allGroups = rootState.account.currentClient.groups;
        const groups = [];
        const cities = [];
        res.data.data.getPaginated.items.map((coord) => {
          if (
            !groups.find((group) => group.value === coord.group_id)
          ) {
            groups.push({
              value: coord.group_id,
              text: allGroups.find((group) => group.uuid === coord.group_id)
                ? allGroups
                  .find((group) => group.uuid === coord.group_id)
                  .group_name.toLowerCase()
                  .split(' ')
                  .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(' ')
                : undefined,
            });
          }

          // if (
          //   !cities.find(city => {
          //     return city.value === coord.group_id;
          //   })
          // ) {
          //   cities.push({
          //     value: coord.group_id,
          //     text: allGroups.find(group => {
          //       return group.uuid === coord.group_id;
          //     })
          //       ? allGroups.find(group => {
          //           return group.uuid === coord.group_id;
          //         }).address.city
          //       : undefined
          //   });
          // }
        });
        commit(
          'filters/setDevicesFilterOptions',
          {
            groups,
            cities,
          },
          { root: true },
        );
        commit('setDeviceLocations', res.data.data.getPaginated.items);
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch((error) => {
        commit('loading/setLoading', false, { root: true });
        reject(error);
      });
  }),
};

// mutations
const mutations = {
  setDeviceLocations(state, payload) {
    state.devices = [];
    state.devicesReady = false;
    payload.map((loc) => {
      loc.lat = Number(loc.latitude);
      loc.lng = Number(loc.longitude);
      loc.infoOpen = false;
      loc.position = {
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      };
      loc.id = loc.screen_id;
    });
    const deviceArray = [];
    const coords = [];
    payload.map((coord) => {
      if (coord.created_at) {
        coords.push(coord);
      }
    });
    coords.sort((a, b) => b.created_at.toString().localeCompare(a.created_at.toString()));
    coords.map((device) => {
      if (deviceArray.filter((e) => e.id === device.id).length > 0) {
        device;
      } else {
        deviceArray.push(device);
      }
    });
    state.devicesReady = true;
    state.devices = deviceArray;
  },
  setGroupLocations(state, payload) {
    state.groupLocations = payload;
  },
  setMapData(state, payload) {
    state.mapData = payload;
  },
  setUnitInfo(state, payload) {
    state.unitInfo = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
